import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=90f34462&scoped=true&"
import script from "./contentDetail.vue?vue&type=script&lang=js&"
export * from "./contentDetail.vue?vue&type=script&lang=js&"
import style0 from "./contentDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./contentDetail.vue?vue&type=style&index=1&id=90f34462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f34462",
  null
  
)

export default component.exports